import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { styles } from "./skeleton-circle.css";

/**
 * A skeleton loading circle with shimmer animation
 */
@customElement("skeleton-circle")
export class SkeletonCircle extends LitElement {
  static override styles = styles;

  /**
   * Size of the skeleton circle. Can be any valid CSS size value.
   * Since circles are always square, this sets both width and height.
   * @default "32px"
   */
  @property({ type: String })
  size = "32px";

  /**
   * Elevation level that controls the background color depth.
   * Higher elevation appears "closer" with darker colors.
   * @default 0
   */
  @property({ type: Number })
  elevation: 0 | 1 | 2 = 0;

  protected override updated() {
    // Update CSS custom properties when size or elevation changes
    this.style.setProperty("--size", this.size);
    this.style.setProperty("--elevation", this.elevation.toString());
  }

  protected override render() {
    return html` <div class="shimmer" aria-hidden="true"></div> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "skeleton-circle": SkeletonCircle;
  }
}
